import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

/** Set from party mode detail: `/party/play/:shellId?trial=1` */
export function usePartyPlayTrialMode(): boolean {
  const [searchParams] = useSearchParams();
  return useMemo(() => searchParams.get("trial") === "1", [searchParams]);
}
